import { useEffect, useState, type PropsWithChildren } from "react";

import { useGetProfile, useSubscribeNotifications } from "@/api/bale";

export function ServiceWorkerProvider({ children }: PropsWithChildren) {
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | undefined>();
  const { mutate: registerForNotifications } = useSubscribeNotifications();
  const me = useGetProfile("@me", {
    query: { select: (data) => data.data.profile },
  });

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/bale-serviceworker.js", { scope: "/", type: "module" })
        .then((registration) => setRegistration(registration))
        .catch((error: unknown) => console.error("Service worker registration failed", error));
    }
  }, []);

  useEffect(() => {
    if (me.data?.id && registration && "pushManager" in registration) {
      registration.pushManager
        .subscribe({ userVisibleOnly: true, applicationServerKey: import.meta.env.VITE_WEBPUSH_PUBLIC_KEY })
        .then((subscription) => {
          registerForNotifications({
            data: {
              platform: "Web",
              endpoint: subscription.endpoint,
              p256dh: new Uint8Array(subscription.getKey("p256dh")!).toBase64(),
              auth: new Uint8Array(subscription.getKey("auth")!).toBase64(),
              encodings: PushManager.supportedContentEncodings as string[],
            },
          });
        })
        .catch((error: unknown) => console.error("Push notification registration failed", error));
    }
  }, [registration, me.data?.id, registerForNotifications]);

  return <>{children}</>; // oxlint-disable-line jsx-no-useless-fragment
}
